import {ApplicationConfig, enableProdMode, Type} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';

function setUpGtm(identifier: string): void {
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${identifier}');`;
    document.head.insertBefore(script, document.head.childNodes[0]);

    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', `https://www.googletagmanager.com/ns.html?id=${identifier}`);
    iframe.setAttribute('height', '0');
    iframe.setAttribute('width', '0');
    iframe.setAttribute('style', 'display:none;visibility:hidden');
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.childNodes[0]);
}

export function bootstrapApplicationStandalone<AppComponent>(
    appComponent: Type<AppComponent>,
    providers: ApplicationConfig['providers'],
    environment: {PRODUCTION: boolean},
    shouldSetUpGTM = true
): void {
    if (environment.PRODUCTION) {
        enableProdMode();
    }

    if (shouldSetUpGTM) {
        const gtmIdentifier = 'GTM-PDV4CH6';
        setUpGtm(gtmIdentifier);
    }

    bootstrapApplication(appComponent, {
        providers: providers
    }).catch((err) => console.error(err));
}
